import
{
    SURVEYSSCREEN_LOAD,
    SURVEYSSCREEN_UNLOAD,
    SURVEYSSCREEN_SET,
} from '../../../../actionDefinitions';
import { createReducer } from '../../../../reducerUtils';

const initialState =
{
    startDate: undefined,
    endDate: undefined,
};

const handlers = {
    [SURVEYSSCREEN_LOAD]: (state, action) =>
    {
        if (action.error)
        {
            return { error: action.payload };
        }
        return { ...action.payload, dataLoaded: true }
    },
    [SURVEYSSCREEN_UNLOAD]: () => initialState,
    [SURVEYSSCREEN_SET]: (state, action) => action.updatedProps,
};

export default createReducer(initialState, handlers);
